import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import Menu from '../../panel/Menu';
import moment from 'moment';
import { FaUsers, FaCalendarAlt } from 'react-icons/fa';

function Otabookings() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
    });

    const [userData, setUserData] = useState();
    const [bookingData, setbookingData] = useState([]);

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchData();
        });
    }, [userData]);

    const fetchData = async () => {
        try {

            const xmlData = `<?xml version="1.0" encoding="UTF-8"?>
<request type="3" timestamp="1436931804">
    <criteria status="AmendBooking" to="2020-04-30T00:00:00+07:00" from="2020-04-01T00:00:00+07:00">
        <property id="10730279"/>
    </criteria>
</request>`;

            try {
                const response = await fetch(
                    "https://supply.agoda.com/api?apiKey=ADDYOURAPIKEYHERE",
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "text/xml",
                        },
                        body: xmlData,
                    }
                );

                const textResponse = await response.text(); // XML response as text
                console.log("Response:", textResponse);
            } catch (error) {
                console.error("Error:", error);
            }


        } catch (error) {
            Toast.fire({ icon: 'error', title: error.message });
            console.error(error);
        }
    };


    return (
        <div className="d-flex">
            <Menu />
            <div className="content-wrapper" style={{ backgroundColor: '#f9f9f9', minHeight: '100vh', flex: 1, padding: '20px' }}>
                <section className="content">
                    <button className="btn btn-secondary mb-3">|| OTA Dashboard ||</button>
                    {/* Agoda Section */}
                    <h5 className="mt-4">📌 Agoda Bookings</h5>
                    <div className="table-responsive mt-2">
                        <table className="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th>Customer Name</th>
                                    <th>Phone</th>
                                    <th>Check-in</th>
                                    <th>Check-out</th>
                                    <th>Room</th>
                                    <th>Status</th>
                                    <th>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bookingData.length === 0 ? (
                                    <tr><td colSpan="7" className="text-center">No bookings found</td></tr>
                                ) : (
                                    bookingData.map((item) => (
                                        <tr key={item.id}>
                                            <td>{item.customerName || "N/A"}</td>
                                            <td>{item.phone || "N/A"}</td>
                                            <td>{item.checkindate}</td>
                                            <td>{item.checkoutdate}</td>
                                            <td>{item.roomno || "N/A"}</td>
                                            <td>{item.status}</td>
                                            <td>{item.amount || 0}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                    {/* Booking.com Section */}
                    <h5 className="mt-4">📌 Booking.com Bookings</h5>
                    <div className="table-responsive mt-2">
                        <table className="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th>Customer Name</th>
                                    <th>Phone</th>
                                    <th>Check-in</th>
                                    <th>Check-out</th>
                                    <th>Room</th>
                                    <th>Status</th>
                                    <th>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bookingData.length === 0 ? (
                                    <tr><td colSpan="7" className="text-center">No bookings found</td></tr>
                                ) : (
                                    bookingData.map((item) => (
                                        <tr key={item.id}>
                                            <td>{item.customerName || "N/A"}</td>
                                            <td>{item.phone || "N/A"}</td>
                                            <td>{item.checkindate}</td>
                                            <td>{item.checkoutdate}</td>
                                            <td>{item.roomno || "N/A"}</td>
                                            <td>{item.status}</td>
                                            <td>{item.amount || 0}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                    {/* Make My Trip Section */}
                    <h5 className="mt-4">📌 MakeMyTrip Bookings</h5>
                    <div className="table-responsive mt-2">
                        <table className="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th>Customer Name</th>
                                    <th>Phone</th>
                                    <th>Check-in</th>
                                    <th>Check-out</th>
                                    <th>Room</th>
                                    <th>Status</th>
                                    <th>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bookingData.length === 0 ? (
                                    <tr><td colSpan="7" className="text-center">No bookings found</td></tr>
                                ) : (
                                    bookingData.map((item) => (
                                        <tr key={item.id}>
                                            <td>{item.customerName || "N/A"}</td>
                                            <td>{item.phone || "N/A"}</td>
                                            <td>{item.checkindate}</td>
                                            <td>{item.checkoutdate}</td>
                                            <td>{item.roomno || "N/A"}</td>
                                            <td>{item.status}</td>
                                            <td>{item.amount || 0}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>


                </section>
            </div>
        </div>
    );
}

export default Otabookings;
